import React, { useContext } from 'react';
import Counter from 'Components/common/Counter/Counter';
import { AppContext } from 'App.context';
import CustomButton from 'Components/common/CustomButton/CustomButton';
import Colors from 'constants/Colors';
import { ReactComponent as RoomSingleIcon } from 'assets/images/room-single.svg';
import { ReactComponent as RoomStandardDoubleIcon } from 'assets/images/room-standard-double.svg';
import { ReactComponent as RoomDoubleDeluxIcon } from 'assets/images/room-double-delux.svg';
import { ReactComponent as RoomSuiteIcon } from 'assets/images/room-suite.svg';
import { ReactComponent as AddIcon } from 'assets/images/add.svg';

import './RoomRow.css';

export default function RoomRow({ room, index, controls, onControlChange, onAddRoom }) {
  const {
    appActions: { translate },
  } = useContext(AppContext);

  const typeOptions = {
    single: {
      icon: <RoomSingleIcon />,
      name: translate('createBooking.steps.selectRooms.roomTypes.single'),
      className: 'room-single',
    },
    standardDouble: {
      icon: <RoomStandardDoubleIcon />,
      name: translate('createBooking.steps.selectRooms.roomTypes.standardDouble'),
      className: 'room-standard-double',
    },
    doubleDelux: {
      icon: <RoomDoubleDeluxIcon />,
      name: translate('createBooking.steps.selectRooms.roomTypes.doubleDelux'),
      className: 'room-double-delux',
    },
    suite: {
      icon: <RoomSuiteIcon />,
      name: translate('createBooking.steps.selectRooms.roomTypes.suite'),
      className: 'room-suite',
    },
  };

  const currentType = typeOptions[room.type];
  const { adults = 1, children = 0, quantity } = controls ?? {};
  const totalGuests = adults + children;

  const getMaxGuests = () => {
    switch (room.type) {
      case 'single':
        return 1;
      case 'standardDouble':
      case 'doubleDelux':
        return 2;
      default:
        return 5;
    }
  };

  const maxGuests = getMaxGuests();

  return (
    <tr>
      <td>
        <span className={`room-name ${currentType.className}`}>
          {currentType.icon} {currentType.name}
        </span>
      </td>
      <td>{room.price}</td> 
      {/* <td>{room.available}</td> */}
      <td>
        <Counter
          value={adults > 0 ? adults : 1}
          onChange={value => {
            if (value >= 1 && value + children <= maxGuests) {
              onControlChange({ index, key: 'adults', value });
            }
          }}
          min={0}
          max={maxGuests - children}
        />
      </td>
      <td>
        <Counter
          value={children}
          onChange={value => {
            if (adults + value <= maxGuests) {
              onControlChange({ index, key: 'children', value });
            }
          }}
          min={0}
          max={maxGuests - adults}
        />
      </td>
      {/* <td>
        <Counter
          value={quantity}
          onChange={value => {
            onControlChange({ index, key: 'quantity', value });
          }}
          min={0}
          max={room.available}
        />
      </td> */}
      <td>
        <CustomButton
          text={translate('createBooking.steps.selectRooms.select')}
          background={Colors.blueColor}
          color={'white'}
          onClick={() => onAddRoom({ index, adults, children, quantity })}
          // disabled={!((adults > 0 || children > 0) && quantity > 0)}
          disabled={adults < 1 || totalGuests === 0}
          leftComponent={<AddIcon />}
          noShadow={true}
        ></CustomButton>
      </td>
    </tr>
  );
}
